<template>
  <div class="about">
    <img
      alt="Vue logo"
      src="../assets/logo.png"
      width="20%"
      height="100px"
    >
    <div class="animated fadeIn">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
      />

      <h1>Esta pagina é sobre a empresa</h1>
    </div>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'Users',
  components: { Loading },
  data() {
    return {
    }
  },
  async beforeMount() {
    this.isLoading = true
    this.isLoading = false
  },

}

</script>